<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="订单编号">
                  <!--                  <el-input style='width: 177px;' v-model="queryForm.orderStatus"></el-input>-->
                  <el-input style='width: 177px;' v-model="queryForm.orderCode"></el-input>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName" title="选择用户"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="订单状态">
<!--                  <el-input style='width: 177px;' v-model="queryForm.orderStatus"></el-input>-->
                  <el-select
                      style="width: 177px"
                      v-model="queryForm.orderStatus"
                      placeholder="请选择"
                      clearable
                      size="small"
                  >
                      <el-option v-for="(item, index) in statusList" :key="index" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getLifeFuelOrderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addLifeFuelOrder"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editLifeFuelOrder(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteLifeFuelOrder(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshLifeFuelOrderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
    <!-- 列表数据 -->
    <el-table
      :data="lifeFuelOrderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="channelOrderId"
        label="相关订单号"
        width="330"
      >
            <template slot-scope="scope">
                <!-- <div style="text-align: left">易购订单id：{{ scope.row.channelOrderId }}</div> -->
                <div style="text-align: left">演出订单code：{{ scope.row.orderCode }}</div>
                <div style="text-align: left">演出名称：{{ scope.row.performanceName }}</div>
                <!-- <div style="text-align: left">演出订单Id：{{ scope.row.fuelOrderId }}</div> -->
                <!-- <div style="text-align: left">扩展业务单号（辅助核销）：{{ scope.row.spOrderId }}</div> -->
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderPrice"
        label="订单总价"
        width="180"
      > </el-table-column>
      <!-- <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="actualPrice"
        label="订单实付金额"
        width="180"
      > </el-table-column> -->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="money"
        label="购票人信息"
        width="180"
      > 
        <template slot-scope="scope">
            <div v-if="scope.row.user">
                <div style="text-align: left">姓名：{{ scope.row.takerName }}</div>
                <div style="text-align: left">电话：{{ scope.row.takerPhone }}</div>
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderStatus"
        label="订单状态"
        width="180"
      >
          <template slot-scope="scope">
              {{getFuelValue(scope.row.orderStatus)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="下单时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkLifeFuelOrder(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editLifeFuelOrder(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteLifeFuelOrder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="lifeFuelOrderStates[lifeFuelOrderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="lifeFuelOrder"
          ref="lifeFuelOrderForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="订单总价"
            prop="orderPrice"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="lifeFuelOrder.orderPrice"
              :disabled="lifeFuelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="购票人姓名"
            prop="actualPrice"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="lifeFuelOrder.takerName"
              :disabled="lifeFuelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="购票人电话"
            prop="money"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="lifeFuelOrder.takerPhone"
              :disabled="lifeFuelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="lifeFuelOrder.userId"-->
<!--              :disabled="lifeFuelOrderState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName" :disabled="lifeFuelOrderState == 'check'" title="选择用户"
                           labelValue="id" :value="lifeFuelOrder.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="订单状态"
            prop="orderStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="lifeFuelOrder.orderStatus"-->
<!--              :disabled="lifeFuelOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width: 177px"
                  :disabled="lifeFuelOrderState == 'check'"
                  v-model="lifeFuelOrder.orderStatus"
                  placeholder="请选择"
                  clearable
                  size="small"
              >
                  <el-option v-for="(item, index) in statusList" :key="index" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="lifeFuelOrderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetLifeFuelOrderList();
                    this.getLifeFuelOrderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetLifeFuelOrderList();
                    this.getLifeFuelOrderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     orderPrice: '', //订单总价
                     actualPrice: '', //订单实付金额
                     money: '', //使用金额
                     userId: '', //用户id
                     orderStatus: '', //订单状态
                    orderId: ''
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                lifeFuelOrderState: 'add',
                lifeFuelOrderStates: {
                    add: '新建演出订单',
                    check: '查看演出订单',
                    edit: '修改演出订单'
                },

                multipleSelection: [],
                lifeFuelOrderList: [],
                lifeFuelOrder: {
                    id: '', //ID
                    orderPrice: '', //订单总价
                    actualPrice: '', //订单实付金额
                    money: '', //使用金额
                    userId: '', //用户id
                    orderStatus: '', //订单状态
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    orderPrice: [{ required: true, message: '订单总价不能为空', trigger: 'blur' }],
                    actualPrice: [{ required: true, message: '订单实付金额不能为空', trigger: 'blur' }],
                    money: [{ required: true, message: '使用金额不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户id不能为空', trigger: 'blur' }],
                    orderStatus: [{ required: true, message: '订单状态不能为空', trigger: 'blur' }],
                },
                statusList: [],
            };
        },
        created() {
            this.getLifeFuelOrderList();
            this.getFuel();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetLifeFuelOrderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.lifeFuelOrderList = [];
            },
            getValueUser(value) {
                this.lifeFuelOrder.userId = value
            },
            getSeachValueUser(value){
                this.queryForm.userId = value
            },
            resetDialog() {
                this.lifeFuelOrderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      orderPrice: '', //订单总价
                      actualPrice: '', //订单实付金额
                      money: '', //使用金额
                      userId: '', //用户id
                      orderStatus: '', //订单状态
                    orderId: ''
                };
                this.getLifeFuelOrderList();
            },
            getFuel(){
                get(`/life/utils/getEnum`,{"enumType": "fuel_order_status"}).then((res) => {
                    if (res.success) {
                        this.statusList = res.enumList;
                    }
                });
            },
            getFuelValue(params) {
                for (let i = 0; i < this.statusList.length; i++){
                    if (this.statusList[i].key == params) {
                        return this.statusList[i].value
                    }
                }
            },
            closeDialog() {
                this.showDialog = false
                this.lifeFuelOrder = {
                      id: '', //ID
                      orderPrice: '', //订单总价
                      actualPrice: '', //订单实付金额
                      money: '', //使用金额
                      userId: '', //用户id
                      orderStatus: '', //订单状态
                };
            },
    
            submitForm() {
                if (this.lifeFuelOrderState == 'add') {
                    this.$refs.lifeFuelOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/life/performorder/add`,{ ...this.lifeFuelOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetLifeFuelOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.lifeFuelOrderState == 'edit') {
                    this.$refs.lifeFuelOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.lifeFuelOrder.user
                            post(`/life/performorder/edit`,{ ...this.lifeFuelOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetLifeFuelOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addLifeFuelOrder() {
                this.showDialog = true;
                this.lifeFuelOrderState = 'add';
            },
            checkLifeFuelOrder(lifeFuelOrderId) {
                console.log(lifeFuelOrderId);
                this.currentLifeFuelOrderId = lifeFuelOrderId;

                this.getLifeFuelOrderById();
                this.showDialog = true;
                this.lifeFuelOrderState = 'check';
            },
            editLifeFuelOrder(lifeFuelOrderId) {
                console.log('lifeFuelOrder', lifeFuelOrderId);
                if (lifeFuelOrderId) {
                    this.currentLifeFuelOrderId = lifeFuelOrderId;
                    this.getLifeFuelOrderById();
                } else {
                    this.lifeFuelOrder = { ...this.lifeFuelOrder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.lifeFuelOrderState = 'edit';
            },
            deleteLifeFuelOrder(lifeFuelOrderId) {
                let ids = '';
                if (lifeFuelOrderId) {
                    ids = lifeFuelOrderId;
                } else {
                    ids = this.multipleSelection.map((lifeFuelOrder) => lifeFuelOrder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/life/performorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetLifeFuelOrderList();
                                this.getLifeFuelOrderList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshLifeFuelOrderList() {
                this.resetLifeFuelOrderList();
                this.getLifeFuelOrderList();
            },
            getLifeFuelOrderList(query = {}) {
                this.loading = true;
                get(`/life/performorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.lifeFuelOrderList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getLifeFuelOrderById() {
                get(`/life/performorder/get`,{ id: this.currentLifeFuelOrderId }).then((res) =>{
                    if(res.success){
                      this.lifeFuelOrder = { ...this.lifeFuelOrder, ...res.lifeFuelOrder };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportLifeFuelOrderList() {
                //this.btnLoading = true;
                exprotExcel(`/life/performorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/life/performorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/life/performorder/importData`,formData);
              this.refreshLifeFuelOrderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getLifeFuelOrderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getLifeFuelOrderList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>